import CapturiLogo from '@capturi/assets/images/logo/puzzel_conversational_intelligence.svg'
import { Box, Flex, Text } from '@chakra-ui/react'
import type { FC } from 'react'

const CapturiFooter: FC = () => {
  return (
    <Flex
      height="45px"
      bg="greys.white"
      justifyContent="center"
      borderTop="1px solid"
      borderColor="greys.100"
    >
      <Flex alignItems="center">
        <Text color="greys.400" mr="2">
          Powered by
        </Text>
        <Box
          filter="drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1)) 
         drop-shadow(0 2px 2px rgba(0, 0, 0, 0.09))  
         drop-shadow(0 5px 3px rgba(0, 0, 0, 0.05))
         drop-shadow(0 10px 4px rgba(0, 0, 0, 0.01))
         drop-shadow(0 15px 4px rgba(0, 0, 0, 0));"
        >
          <CapturiLogo />
        </Box>
      </Flex>
    </Flex>
  )
}

export default CapturiFooter
